import type { Module } from 'vuex';
import { UserWallet } from '@/types/UserWallet';
import {RootState} from "@/store";

export interface UserWalletState {
  userWallets: UserWallet[];
}

const userWalletModule: Module<UserWalletState, RootState> = {
  namespaced: true,

  state: (): UserWalletState => ({
    userWallets: [],
  }),

  getters: {
    getUserWalletById: (state) => (idUserWallet: number): UserWallet | undefined => {
      return state.userWallets.find(userWallet => userWallet.idUserWallet === idUserWallet);
    },
  },

  mutations: {
    setUserWallets(
      state,
      payload: { userWallets: Record<number, any> }
    ) {
      state.userWallets = Object
        .values(payload.userWallets)
        .map(UserWallet.fromRaw);
    },

    setUserWalletCreate(
      state,
      payload: {
        idUserWallet: number;
        idUser: number;
        idBlockchainAddress: number;
        address: string;
        tag: string | null;
      }
    ) {
      const raw = {
        idUserWallet: payload.idUserWallet,
        idUser: payload.idUser,
        idBlockchainAddress: payload.idBlockchainAddress,
        address: payload.address,
        tag: payload.tag,
      };
      state.userWallets.push(UserWallet.fromRaw(raw));
    },

    setUserWalletUpdate(
      state,
      payload: {
        idUserWallet: number;
        idBlockchainAddress?: number;
        address?: string;
        tag?: string | null;
      }
    ) {
      const userWallet = state.userWallets.find(
        userWallet => userWallet.idUserWallet === payload.idUserWallet
      );
      if (!userWallet) return;
      if (payload.idBlockchainAddress !== undefined) {
        userWallet.idBlockchainAddress = payload.idBlockchainAddress;
      }
      if (payload.address !== undefined) {
        userWallet.address = payload.address;
      }
      if (payload.tag !== undefined) {
        userWallet.tag = payload.tag;
      }
    },

    setUserWalletDelete(
      state,
      payload: { idUserWallet: number }
    ) {
      state.userWallets = state.userWallets.filter(
        userWallet => userWallet.idUserWallet !== payload.idUserWallet
      );
    },
  },

  actions: {
    wsSetUserWallets({ commit }, payload) {
      commit('setUserWallets', payload);
    },
    wsUserWalletCreate({ commit }, payload) {
      commit('setUserWalletCreate', payload);
    },
    wsUserWalletUpdate({ commit }, payload) {
      commit('setUserWalletUpdate', payload);
    },
    wsUserWalletDelete({ commit }, payload) {
      commit('setUserWalletDelete', payload);
    },
  },
};

export default userWalletModule;
